<template lang="pug">
v-container
  v-row(justify="center")
    v-col.pb-0(cols="12" md="5" lg="4")

      v-container.pb-0
        v-row(no-gutters)
          v-col
            .text-h3.font-weight-bold.text-center {{ organization.businessName }}
            .subtitle-2.text-center.mt-4 {{ $t("бин_иин") }}: {{ organization.businessId }}
            .subtitle-2.text-center.mt-1 {{ $t("знм") }}: {{ cashRegister.serialNumber }}
            template(v-if="cashRegister.status !== 'TRIAL'")
              .subtitle-2.text-center.mt-1 {{ $t(`fdo.${cashRegister.fdo}.title`) }} {{ cashRegister.fdo === 'REK' ? '(ОФД re:Kassa)' : '' }}

            // ЛС от ОФД Comrun
            .subtitle-2.text-center.mt-1(v-if="organization && organization.accountNumber && cashRegister.fdo === 'REK'") {{ $t("лицевой_счёт") }}:
              a.subtitle-2(@click="$router.push('/miniapp?name=account')") &nbsp;{{ organization.accountNumber }}

            // ЛС от других ОФД
            .subtitle-2.text-center.mt-1(v-if="preferences && preferences.ofd && preferences.ofd.accountId") {{ $t("лицевой_счёт") }}:
              a.subtitle-2(@click="$router.push('/kkm/fdo/payment-methods')") &nbsp;{{ preferences.ofd.accountId }}

            h2.subtitle-2.text-center.mt-1(v-if="cashRegisterStatus !== 'ONLINE'") {{ $t("статус") }}:&nbsp;&nbsp;
              v-chip.font-weight-bold.px-2(small :color="$t(`cashRegister.color.${cashRegisterStatus}`)") {{ $t(`cashRegister.status.${cashRegisterStatus}`) }}
                span(v-if="cashRegister.fdoMode === 'OFFLINE' && hoursLeftTillBlocked !== null && hoursLeftTillBlocked >= 0") &nbsp; ({{ hoursLeftTillBlocked }} {{ $t("час") }})

        v-row.mt-4(v-if="user._links.createCashRegister")
          v-col.text-center
            v-btn(color="primary" block @click="showCashRegisterSwitch(true); analyticsLogEvent({ eventName: 're_cash_click_button' })")
              v-icon(left) mdi-format-list-bulleted
              |  {{ $t("мои_кассы") }}

  v-row(justify="center")
    v-col(cols="12" md="5" lg="4")
      v-subheader {{ $t("настройки") }}

      v-list.px-0.pa-md-3.rounded-xl
        v-list-item(@click="routeTo('/kkm/settings', 'kkmSettings')" v-if="cashRegister.status === 'REGISTERED' || cashRegister.status === 'DEREGISTERED'")
          v-list-item-icon.ml-2
            v-icon mdi-calculator
          v-list-item-content
            v-list-item-title {{ $t("настройки_кассы") }}
            v-list-item-subtitle
          v-list-item-action
            v-icon(style="font-size: 30px;") mdi-menu-right

        v-list-item(@click="routeTo('/receipt/settings', 'receiptSettings')")
          v-list-item-icon.ml-2
            v-icon mdi-receipt
          v-list-item-content
            v-list-item-title {{ $t("настройки_чека") }}
          v-list-item-action
            v-icon(style="font-size: 30px;") mdi-menu-right

        v-list-item(@click="routeTo('/printer/settings', 'printerSettings')")
          v-list-item-icon.ml-2
            v-icon mdi-printer
          v-list-item-content
            v-list-item-title {{ $t("настройки_принтера") }}
            v-list-item-subtitle(v-if="printer.connectionType === 'bluetooth' && printer.bluetooth.name") {{ printer.bluetooth.name }}
            v-list-item-subtitle(v-if="printer.connectionType === 'wifi' && printer.wifi.name") {{ printer.wifi.name }}
          v-list-item-action
            v-icon(style="font-size: 30px;") mdi-menu-right

        v-list-item(@click="routeTo('/kkm/positions', 'priceList')")
          v-list-item-icon.ml-2
            v-icon mdi-tag-text-outline
          v-list-item-content
            v-list-item-title {{ $t("прайс_лист") }}
          v-list-item-action
            v-icon(style="font-size: 30px;") mdi-menu-right

        v-list-item(@click="routeTo('/kkm/access-users', 'accessUsers')" v-if="!readonly")
          v-list-item-icon.ml-2
            v-icon mdi-account-group
          v-list-item-content
            v-list-item-title {{ $t("кассиры_пользователи") }}
          v-list-item-action
            v-icon(style="font-size: 30px;") mdi-menu-right

        v-list-item(@click="routeTo('/partners', 'partners')" v-if="!readonly && hasConnectedPartners")
          v-list-item-icon.ml-2
            v-icon mdi-application
          v-list-item-content
            v-list-item-title {{ $t("партнеры") }}
          v-list-item-action
            v-icon(style="font-size: 30px;") mdi-menu-right

        v-list-item(@click="routeTo('/kkm/access-api', 'accessApi')" v-if="!readonly")
          v-list-item-icon.ml-2
            v-icon mdi-apps-box
          v-list-item-content
            v-list-item-title {{ $t("сторонние_приложения") }}
          v-list-item-action
            v-icon(style="font-size: 30px;") mdi-menu-right

        //- HALYK_QR_ROLLOUT_GATE
        v-list-item(@click="routeTo('/kkm/halyk/qr', 'halykQr')" v-if="!readonly && halykQRAvailable")
          v-list-item-icon.ml-2
            v-icon mdi-qrcode
          v-list-item-content
            v-list-item-title {{ $t("единый_qr") }}
          v-list-item-action
            v-icon(style="font-size: 30px;") mdi-menu-right

        v-list-item(@click="openLocaleTypeDialog()")
          v-list-item-icon.ml-2
            v-icon mdi-translate
          v-list-item-content
            v-list-item-title {{ $t("язык") }}
          v-list-item-content.re-text-align-end
            v-list-item-action-text.subtitle-1 {{ dictionary.localeType[locale].title }}

        v-list-item
          v-list-item-icon.ml-2
            v-icon mdi-theme-light-dark
          v-list-item-content
            v-list-item-title {{ $t("темная_тема") }}
          v-list-item-action
            v-switch(color="teal" :input-value="darkTheme" @change="darkThemeChanged")

    v-col(cols="12" md="5" lg="4")
      template
        div.my-1

        v-subheader {{ $t("помощь") }}

        v-list.px-0.pa-md-3.rounded-xl
          v-list-item(@click="showSafety()")
            v-list-item-icon.ml-2
              v-icon mdi-security
            v-list-item-content
              v-list-item-title {{ $t("безопасность") }}
            v-list-item-action
              v-icon(style="font-size: 30px;") mdi-menu-right

          v-list-item(@click="showManual()")
            v-list-item-icon.ml-2
              v-icon mdi-book-information-variant
            v-list-item-content
              v-list-item-title {{ $t("инструкции") }}
            v-list-item-action
              v-icon(style="font-size: 30px;") mdi-menu-right

          v-list-item(@click="routeTo('/kkm/legal-and-regulatory', 'legalAndRegulatory')")
            v-list-item-icon.ml-2
              v-icon mdi-note-text
            v-list-item-content
              v-list-item-title {{ $t("правовая_информация") }}
            v-list-item-action
              v-icon(style="font-size: 30px;") mdi-menu-right

      v-subheader.mt-md-2.mt-7 {{ $t("профиль") }}

      v-list.px-0.pa-md-3.rounded-xl
        v-list-item(@click="routeTo('/profile', 'profileSettings')" :disabled="!user._links.createCashRegister")
          v-list-item-icon.ml-2
            v-icon mdi-account
          v-list-item-content
            v-list-item-title {{ $t("мой_профиль") }}: {{ user.name }}
            v-list-item-title.mt-2.text-h5.re-number-font {{ user.phone | phone }}
          v-list-item-action
            v-icon(style="font-size: 30px;") mdi-menu-right

      v-btn.mt-4.white--text(block color="danger" @click="preSignOut()")  {{ $t("выйти") }}

  div.mt-6(align="center")
    v-btn(large icon @click="$openLink('https://link.rekassa.kz/instagram', '_system'); analyticsLogEvent({ eventName: 're_settings_social_clicked', eventProperties: { social_platform: 'instagram' } })")
      v-icon mdi-instagram
    v-btn(large icon @click="$openLink('https://link.rekassa.kz/youtube', '_system'); analyticsLogEvent({ eventName: 're_settings_social_clicked', eventProperties: { social_platform: 'youtube' } })")
      v-icon mdi-youtube
    v-btn(large icon @click="$openLink('https://link.rekassa.kz/telegram', '_system'); analyticsLogEvent({ eventName: 're_settings_social_clicked', eventProperties: { social_platform: 'telegram' } })")
      v-icon mdi-send
    v-btn(large icon @click="$openLink('https://link.rekassa.kz/facebook', '_system'); analyticsLogEvent({ eventName: 're_settings_social_clicked', eventProperties: { social_platform: 'facebook' } })")
      v-icon mdi-facebook

  div.mt-2.mb-8(align="center")
    span.text-subtitle-1 &copy; COMRUN
    span.mx-2 &bull;
    a.text-subtitle-1.mb-3(@click="$openLink(`https://link.rekassa.kz/rekassa-website-${locale}`, '_system'); analyticsLogEvent({ eventName: 're_settings_social_clicked', eventProperties: { social_platform: 'website' } })") rekassa.kz
    div.text-subtitle-1 {{cordovaBuildVersion ? `v.${cordovaBuildVersion}` : ''}}

  v-dialog(v-model="localeTypeDialog" max-width="400px")
    v-card
      v-card-title.pb-0
        span.headline {{ $t("выберите_язык") }}
      v-card-text
        v-container
          v-form.mt-3(ref="localeTypeForm" @submit.prevent="saveLocaleType()")
            v-radio-group(v-model="localeTypeRadio")
              v-radio(v-for="(item, $index) in localeTypes" :key="'l_' + $index" :label="item.title" :value="item.value")
      v-divider
      v-card-actions
        v-spacer
        v-btn(outlined @click="localeTypeDialog = false") {{ $t("отменить") }}
        v-btn(color="primary" @click="saveLocaleType()") {{ $t("сохранить") }}

</template>
<script>
import { mapActions, mapState } from 'vuex'
import { getLocale, changeLocale } from '../../i18n/index'
import dictionaryMixin from '../../mixins/dictionaryMixin'
// HALYK_QR_ROLLOUT_GATE: даёт halykQRAvailable для пункта «Единый QR»
import qrPaymentMixin from '../../mixins/qrPaymentMixin'

export default {

  mixins: [dictionaryMixin, qrPaymentMixin],

  data: () => ({
    darkTheme: false,

    localeTypeRadio: null,
    localeTypeDialog: false,
  }),

  computed: {
    ...mapState({
      user: state => state.auth.user,
      roles: state => state.cashRegisters.cashRegister.roles,
      cashRegister: state => state.cashRegisters.cashRegister.cashRegister,
      organization: state => state.cashRegisters.cashRegister.organization,
      configuration: state => state.cashRegisters.cashRegister.cashRegister.data.configuration,
      printer: state => state.printer.printer,
      cordovaBuildVersion: state => state.tools.cordovaBuildVersion,
      preferences: state => state.cashRegisters.cashRegister.cashRegister.data.preferences,
    }),

    locale() {
      return getLocale()
    },

    cashRegisterStatus() {
      const { status, fdoMode } = this.cashRegister
      if (status === 'REGISTERED') {
        return fdoMode
      }
      return status
    },

    hoursLeftTillBlocked() {
      return this.cashRegister && this.cashRegister.offlineExpireTime ? Math.floor(this.$moment.duration(this.$moment(this.cashRegister.offlineExpireTime).diff(new Date())).asHours()) : null
    },

    readonly() {
      return this.cashRegister.status === 'TRIAL' || this.cashRegister.status === 'DEREGISTERED' || !this.isOwner || this.user._links.createCashRegister === undefined
    },

    isOwner() {
      return this.roles.find(r => r === 'OWNER') !== undefined
    },

    hasConnectedPartners() {
      return (this.configuration.kaspiQR && this.configuration.kaspiQR.connected)
      || (this.configuration.halyk && this.configuration.halyk.halykPosConnected)
      || (this.configuration.moyuchet && this.configuration.moyuchet.сonnected)
    },
  },

  created() {
    this.localeTypeRadio = this.locale
    this.darkTheme = localStorage.getItem('rekassa.kz-ui-theme') === 'dark'
  },

  methods: {
    ...mapActions({
      signOut: 'auth/signOut',
      showCashRegisterSwitch: 'tools/showCashRegisterSwitch',
      analyticsLogEvent: 'analytics/logEvent',
      showSnackbar: 'tools/showSnackbar',
      showConfirm: 'confirm/showConfirm',
    }),

    routeTo(route, event) {
      this.$router.push(route)
      this.analyticsLogEvent({ eventName: 're_settings_click_button', eventProperties: { section: event } })
    },

    darkThemeChanged(val) {
      this.$vuetify.theme.dark = val
      this.darkTheme = val

      if (this.$isCordova()) {
        if (val) {
          window.StatusBar.styleLightContent()
          window.StatusBar.backgroundColorByHexString('#1E2E31')
        } else {
          window.StatusBar.styleDefault()
          window.StatusBar.backgroundColorByHexString('#F4F4F4')
        }
      }

      localStorage.setItem('rekassa.kz-ui-theme', val ? 'dark' : 'light')
      this.analyticsLogEvent({ eventName: 're_cash_ui_theme_change', eventProperties: { theme: this.darkTheme ? 'dark' : 'white' } })
      if (val) {
        this.analyticsLogEvent({ eventName: 're_cash_ui_dark_theme_enabled' })
      }
    },

    openLocaleTypeDialog() {
      this.localeTypeRadio = this.locale
      this.localeTypeDialog = true
    },

    saveLocaleType() {
      if (this.$refs.localeTypeForm.validate()) {
        this.localeTypeDialog = false
        changeLocale(this.localeTypeRadio)
        this.analyticsLogEvent({ eventName: 're_cash_ui_language_change', eventProperties: { language: this.localeTypeRadio } })
      }
    },

    preSignOut() {
      this.showConfirm({
        title: this.$t('вы_уверены_что_хотите_выйти_из_приложения'),
        resolveText: this.$t('выйти'),
        rejectText: this.$t('отменить'),
        resolveCallback: () => new Promise((resolve) => {
          if (!this.$isCordova()) {
            window.HelpCrunch('hideChatWidget')
          }
          this.signOut().then(() => {
            resolve({ hide: true })
          })
        }),
      })
    },

    showSafety() {
      this.showConfirm({
        title: this.$t('безопасность'),
        text: this.$t('в_случае_обнаружения_уязвимостей_или_недостатков_в_защищенности_dotdotdot'),
        resolveText: this.$t('закрыть'),
        resolveCallback: () => new Promise((resolve) => {
          resolve({ hide: true })
        }),
      })
    },

    showManual() {
      this.$openLink(`https://link.rekassa.kz/help-rekassa-${this.locale}`, '_system')
      this.analyticsLogEvent({ eventName: 're_settings_click_button', eventProperties: { section: 'manual' } })
    },
  },
}
</script>

<style lang="stylus">
</style>
